import * as React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export interface ReactLazyExoticComponentWithPrelod<T extends React.ComponentType<any>> extends React.LazyExoticComponent<T> {
    preload?: () => Promise<{ default: T }>
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function lazyWithPreload<T extends React.ComponentType<any>>(factory: () => Promise<{ default: T }>): ReactLazyExoticComponentWithPrelod<T> {
    const Component: ReactLazyExoticComponentWithPrelod<T> = React.lazy<T>(factory);
    Component.preload = factory;
    return Component;
}
